import { useEffect, useState } from "react"
import apiService from "./apiService"
import { setToken } from "./storageService"
import userManager from "./userManager"
import { toast } from "react-toastify";

const useAuth = () => {
    const [isLoggedIn, setLoggedIn] = useState(false)

    const verifyLogin = async () => {
        try {
            const { token } = await apiService.login.login!();
            setToken(token);
            setLoggedIn(true)
        } catch (error) {
            toast.error("Error getting access token. Redirecting to logout page")
            localStorage.clear();
            setTimeout(() => {
                userManager.signoutRedirect()
            }, 5000)
        }
    }

    useEffect(() => {
        const isCallback = window.location.pathname === '/login'
        if (isCallback) {
            userManager.signinRedirectCallback().then(async e => {
                window.history.replaceState({}, '', (e.state as any).path)
                await verifyLogin()
            })
        } else {
            userManager.getUser().then(async user => {
                if (user) {
                    if (user.expired) {
                        localStorage.clear();
                        userManager
                        .signinRedirect({ state: { path: window.location.pathname } })
                        .then(a => {
                            setLoggedIn(false)
                        })
                    } else {
                        verifyLogin()
                    }
                } else {
                    userManager
                        .signinRedirect({ state: { path: window.location.pathname } })
                        .then(a => {
                            setLoggedIn(false)
                        })
                }
            })
        }
    }, [])

    return { isLoggedIn }
}

export default useAuth